var originalFname, originalLname;
$.urlParam = function (name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};

function stringToJson(source) {
  var l = source,
    o = l.split("&"),
    e = {};
  for (var i in o) {
    var t = o[i].split("=");
    if (e[t[0]] != undefined && typeof e[t[0]] == "array") {
      e[t[0]][e[t[0]].length] = decodeURIComponent(t[1]);
    } else if (e[t[0]] != undefined) {
      var n = [];
      n[0] = decodeURIComponent(e[t[0]]);
      n[1] = decodeURIComponent(t[1]);
      e[t[0]] = n;
    } else {
      e[t[0]] = decodeURIComponent(t[1]);
    }
  }
  return e;
}

var isReviewLoaded = false;
$(document).one("DOMNodeInserted", "form#create_customer", function (e) {
  isReviewLoaded = true;
  if (isReviewLoaded) {
  }
});
$(document).ready(function () {
  var get_encodedId = $.urlParam("id");
  var source = $.urlParam("source");
  console.log('source',source)
  if (get_encodedId) {
    var decodedParams = decodeURI(atob(get_encodedId));
    //       console.log(decodedParams);
    var jsonArray = stringToJson(decodedParams);
    console.log(jsonArray);
    $(".ajax-loader").show();
    $("input#orderfirst_name").val(jsonArray.orderfirst_name);
    $("input#orderlast_name").val(jsonArray.orderlast_name);
    $("body").removeClass("shifter-active");
    jQuery.ajax({
      type: "GET",
      url:
        Applink +
        "/Host/GetOrderNew?Number=" +
        jsonArray.order_number +
        "&fname=" +
        jsonArray.orderfirst_name +
        "&lname=" +
        jsonArray.orderlast_name,
      success: function (res) {
        var dbUser = $.parseJSON(res.DBData);
        var dbUserORW = $.parseJSON(res.DBDataORW);
        console.log(res);

        var finalOrder = null;
        if (!$.isEmptyObject(dbUser)) {
          var aliasName = dbUser != null ? dbUser.aliasName : "";
          if (jsonArray.order_number == dbUser.OrderName) {
            finalOrder = dbUser;
          }

          if (finalOrder == null) {
            $(".ajax-loader").hide();
            alert("Order not found. Try again.");
            return false;
          }

          $("#Customername").html(aliasName ? aliasName : dbUser.Name);

          originalFname = $.trim(dbUser.FirstName);
          originalLname = $.trim(dbUser.LastName);
          var finalLineId = dbUser.LineItemId ? dbUser.LineItemId : "";

          $("#CustomerFormLineItemId").val(finalLineId);
          var finalGender = dbUser.Gender.length > 0 ? dbUser.Gender : "";
          var finalGym = dbUser.Gym.length > 0 ? dbUser.Gym : "None";

          var finalHrs = dbUser.Hours;
          var finalMins = dbUser.Minutes;
          var finalSecs = dbUser.Seconds;

          $("#order_number").val(dbUser.OrderName);
          $("#Gender").html(finalGender);
          $("#gymcode").html(finalGym);
          $("#first_name").val(dbUser.FirstName);
          $("#last_name").val(dbUser.LastName);
          $("#CustomerFormGender").val(finalGender);
          $("#CustomerFormGym").val(finalGym);
          $("#CustomerFormOrder").val(jsonArray.order_number);

          OrderMain = finalOrder;

          $(".ajax-loader").hide();
          $("#enterscore").show();
          $(".order-information").hide();
          $("body").addClass("shifter-active");

          // Time check logic
          var hasTmcTime =
            finalHrs != null && finalMins != null && finalSecs != null;
          var hasOrwTime =
            dbUserORW &&
            dbUserORW.Hours != null &&
            dbUserORW.Minutes != null &&
            dbUserORW.Seconds != null;

          // Show TMC time if available
          if (hasTmcTime) {
            $("#murph-time-regular").show();
            $("#tmc-time-title").show();
            $("span#murph-hours").html(finalHrs.toString().padStart(2, "0"));
            $("span#murph-minutes").html(finalMins.toString().padStart(2, "0"));
            $("span#murph-seconds").html(finalSecs.toString().padStart(2, "0"));
          } else {
            $("#murph-time-regular").hide();
            $("#tmc-time-title").hide();
          }

          // Show ORW time if available
          if (hasOrwTime) {
            $("#murph-time-orw, #orw-time-title").show();
            $("#orw-title").show();
            $("span#orw-hours").html(
              dbUserORW.Hours.toString().padStart(2, "0")
            );
            $("span#orw-minutes").html(
              dbUserORW.Minutes.toString().padStart(2, "0")
            );
            $("span#orw-seconds").html(
              dbUserORW.Seconds.toString().padStart(2, "0")
            );
          } else {
            $("#murph-time-orw, #orw-time-title").hide();
            $("#orw-title").hide();
          }

          // Show input if either is missing
          if (!hasTmcTime || !hasOrwTime) {
            $("#timesection").show();
            $("#showtimsection").hide();
          } else {
            $("#timesection").hide();
            $("#showtimsection").show();
          }

          // Update workoutType dropdown based on existing time data
          const $workoutType = $("#workoutType");

          if (hasTmcTime) {
            $workoutType.find('option[value="TMC"]').remove();
          }

          if (hasOrwTime) {
            $workoutType.find('option[value="ORW"]').remove();
          }

          // If both exist, hide or disable the dropdown
          if (hasTmcTime && hasOrwTime) {
            $workoutType.hide(); // or $workoutType.prop('disabled', true);
          } else {
            $workoutType.show(); // ensure it's visible if only one is missing

            // Auto-select remaining option if only one left
            if ($workoutType.find("option").length === 1) {
              $workoutType.prop("selectedIndex", 0);
            }
          }

          return false;
        } else {
          $(".ajax-loader").hide();
          alert("Order not found. Try again.");
          return false;
        }
      },
    });
  }

  $(".redirect-leaderboard").click(function (e) {
    e.preventDefault();
    location.href = "/pages/leaderboard";
  });
});

var OrderMain = null;
jQuery(document).ready(function () {
  //     jQuery("#find-order").click(function() {
  //     });

  try {
    if (Shopify.urlParam("id") != undefined) {
      $('[data-template-handle="page-challengetime"] a#edit_info_btn').attr(
        "href",
        "/pages/update-account?id=" + Shopify.urlParam("id")
      );
    }
  } catch {}

  jQuery("form#form_order_info").validate({
    ignore: [],
    rules: {
      order_number: "required",
      orderfirst_name: { required: true },
      orderlast_name: { required: true },
    },
    messages: {
      order_number: "Please enter Order Number",
      orderfirst_name: {
        required: "Please enter first name",
      },
      orderlast_name: {
        required: "Please enter last name",
      },
    },
    errorElement: "em",
    submitHandler: function (form) {
      //   console.log($(form).serialize());
      var formData = $(form).serialize();
      var order_number = $("#order_number").val();
      var orderfirst_name = $("#orderfirst_name").val();
      var orderlast_name = $("#orderlast_name").val();
      $(".ajax-loader").show();
      $("body").removeClass("shifter-active");

      jQuery.ajax({
        type: "GET",
        url:
          Applink +
          "/Host/GetOrderNew?Number=" +
          order_number +
          "&fname=" +
          orderfirst_name +
          "&lname=" +
          orderlast_name,
        success: function (res) {
          //             var result = $.parseJSON(res.orderData);
          var dbUser = $.parseJSON(res.DBData);
          var dbUserORW = $.parseJSON(res.DBDataORW);
          console.log(res, dbUserORW);
          var finalOrder = null;
          if (!$.isEmptyObject(dbUser) || !$.isEmptyObject(dbUserORW)) {
            var aliasName = dbUser != null ? dbUser.aliasName : "";
            if (order_number == dbUser.OrderName) {
              finalOrder = dbUser;
            }
            if (finalOrder == null) {
              $(".ajax-loader").hide();
              alert("Order not found. try again.");
              return false;
            }

            $("#Customername").html(aliasName ? aliasName : dbUser.Name);

            originalFname = $.trim(dbUser.FirstName);
            originalLname = $.trim(dbUser.LastName);
            var finalGender = dbUser.Gender.length > 0 ? dbUser.Gender : "";
            var finalGym = dbUser.Gym.length > 0 ? dbUser.Gym : "";

            var finalHrs = dbUser.Hours;
            var finalMins = dbUser.Minutes;
            var finalSecs = dbUser.Seconds;
            var finalLineId = dbUser.LineItemId ? dbUser.LineItemId : "";

            $("#CustomerFormLineItemId").val(finalLineId);
            $("#Gender").html(finalGender);
            $("#gymcode").html(finalGym);
            $("#first_name").val(dbUser.FirstName);
            $("#last_name").val(dbUser.LastName);
            $("#CustomerFormGender").val(finalGender);
            $("#CustomerFormGym").val(finalGym);
            $("#CustomerFormOrder").val(order_number);

            OrderMain = finalOrder;
            var isFirst = true;
            if (!isFirst) {
              var offset =
                $(".order-container").offset().top -
                $(".coverheader").outerHeight();
              $(".order-container").addClass("already-open");
              $("html, body").animate(
                {
                  scrollTop: offset,
                },
                500,
                function () {
                  setTimeout(function () {
                    $(".already-posted").animate({ opacity: 1 }, 500);
                    $(".order-information").animate({ opacity: 0 }, 500);
                  }, 300);
                  $("form#create_customer").removeAttr("novalidate");
                }
              );
            } else {
              $(".ajax-loader").hide();
              $("#enterscore").show();
              $(".order-information").hide();

              // Parse and format regular Murph Time
              let hasRegularTime =
                dbUser &&
                dbUser.Hours != null &&
                dbUser.Minutes != null &&
                dbUser.Seconds != null;
              let hasORWTime =
                dbUserORW &&
                dbUserORW.Hours != null &&
                dbUserORW.Minutes != null &&
                dbUserORW.Seconds != null;

              // Show regular time if available
              if (hasRegularTime) {
                $("#murph-hours").html(
                  dbUser.Hours.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
                $("#murph-minutes").html(
                  dbUser.Minutes.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
                $("#murph-seconds").html(
                  dbUser.Seconds.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
                $("#murph-time-regular").show();
              } else {
                $("#murph-time-regular").hide();
              }

              // Show ORW time if available
              if (hasORWTime) {
                $("#orw-time-title").show();
                $("#murph-time-orw").show();
                $("#orw-hours").html(
                  dbUserORW.Hours.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
                $("#orw-minutes").html(
                  dbUserORW.Minutes.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
                $("#orw-seconds").html(
                  dbUserORW.Seconds.toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                  })
                );
              } else {
                $("#orw-time-title").hide();
                $("#murph-time-orw").hide();
              }

              // Show input section if either is missing
              if (!hasRegularTime || !hasORWTime) {
                $("#timesection").show(); // Show input form
                $("#showtimsection").hide(); // Hide display section
              } else {
                $("#timesection").hide(); // Hide input form
                $("#showtimsection").show(); // Show display section
              }

              // Remove already submitted workout types from dropdown
              if (hasRegularTime) {
                $('#workoutType option[value="TMC"]').remove();
              }

              if (hasORWTime) {
                $('#workoutType option[value="ORW"]').remove();
              }

              // If both are filled, disable the dropdown entirely (optional)
              if (hasRegularTime && hasORWTime) {
                $("#workoutType").hide(); // or use .prop('disabled', true);
              }

              if ($("#workoutType option").length === 1) {
                $("#workoutType").prop("selectedIndex", 0);
              }

              $("body").addClass("shifter-active");
            }

            var encodedParams = btoa(encodeURI(formData));
            var source = '';
            if($('body').hasClass('page-challengetime-gym-update')){
              source = '&source=update-gym-info';
            }
            $("a#edit_info_btn").attr(
              "href",
              "/pages/update-account?id=" + encodedParams + source
            );
          } else {
            $(".ajax-loader").hide();
            alert("Order not found. try again.");
            return false;
          }
        },
      });
    },
  });

  jQuery("form#create_customer").validate({
    ignore: [],
    rules: {
      "customer[note][Hr]": { required: true, number: true, maxlength: 2 },
      "customer[note][Minutes]": { required: true, number: true, maxlength: 2 },
      "customer[note][Seconds]": { required: true, number: true, maxlength: 2 },
      "customer[note][Murphtype]": { required: true },
    },
    messages: {
      "customer[note][Hr]": {
        required: "Please enter challenge time",
        maxlength: "Hours should not be greater than 23.",
      },
      "customer[note][Minutes]": {
        required: "Please enter challenge time",
        maxlength: "Minutes should not be greater than 59.",
      },
      "customer[note][Seconds]": {
        required: "Please enter challenge time",
        maxlength: "Seconds should not be greater than 59.",
      },
      "customer[note][Murphtype]": {
        required: "Please select any  Rx'd or Modified option",
      },
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      if (element.attr("type") == "radio") {
        error.insertAfter($(element).parents("div.murphtype-row"));
      } else {
        error.insertAfter($(element));
      }
    },
    submitHandler: function (form) {
      //         console.log(form)
      $.fancybox([{ href: "#challengetim_popup" }]);
      //       $.fancybox.open([{src  : '#challengetim_popup'}]);
    },
  });
  jQuery("#submittime").click(function () {
    $.fancybox.close();
    var hrinput = $.trim($("#CustomerFormHr").val());
    var mininput = $.trim($("#CustomerFormMinutes").val());
    var secondinput = $.trim($("#CustomerFormSeconds").val());
    var workoutType = $.trim($("#workoutType").val());

    var orderfirst_name = $.trim(originalFname);
    var orderlast_name = $.trim(originalLname);
    var ordernumber_hidden = $("#CustomerFormOrder").val();

    //Check challage time entery already present or not

    var isFirst = true;
    $(".ajax-loader").hide();

    if (isFirst) {
      $.ajax({
        url: Applink + "/Host/SetChallengeTime",
        type: "POST",
        data: {
          Gym: $("#CustomerFormGym").val(),
          Gender: $("#CustomerFormGender").val(),
          Hours: $("#CustomerFormHr").val(),
          Minutes: $("#CustomerFormMinutes").val(),
          Seconds: $("#CustomerFormSeconds").val(),
          MurphType: $('[name="customer[note][Murphtype]"]:checked').val(),
          FirstName: orderfirst_name,
          LastName: orderlast_name,
          OrderId: OrderMain.OrderId,
          OrderName: $("#order_number").val(),
          AliasName: $("#alias_name").val(),
          LineItemId: $("#CustomerFormLineItemId").val(),
          SubmitDate: new Date().toJSON().slice(0, 10),
          workoutType: workoutType,
        },
        beforeSend: function () {
          $(".loader-wrapper-inner").css({ top: "20%" });
          $(".ajax-loader").show();
        },
        dataType: "json",
        success: function (data) {
          console.log(data);
          $(".loader-wrapper-inner").removeAttr("style");
          $(".ajax-loader").hide();
          if (data != undefined && data != null) {
            window.location.href = "/pages/post-your-time-confirmation";
          } else {
            alert("Something went wrong, please contact administrator.");
          }
        },
        error: function (data, err) {
          console.log(err);
          alert("Something went wrong, please contact administrator.");
        },
      });
    } else {
      var offset =
        $(".order-container").offset().top - $(".coverheader").outerHeight();
      $(".order-container").addClass("already-open");
      $("html, body").animate(
        {
          scrollTop: offset,
        },
        500,
        function () {
          setTimeout(function () {
            $(".already-posted").animate({ opacity: 1 }, 500);
            $(".order-information").animate({ opacity: 0 }, 500);
          }, 300);
        }
      );
      return false;
    }
  });
});
